module.exports = __webpack_public_path__ + "static/img/Logo_Foxi.871ab2c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Logo_Foxi.png
// module id = yk50
// module chunks = 7